/* Who the signed-in person actually is, from the directory.
 *
 * The intake form printed "RHayes - Dispatcher - Beehive Plumbing" over a real
 * request. Only the first part was true: SWA hands back a UPN, and the role and
 * brand were the prototype's demo profile showing through a screen a real
 * person was filling in.
 *
 * So this asks the server, which asks Graph. Measured on the live tenant
 * (2026-08-17, 844 enabled accounts): mail 99%, jobTitle 11%, department 0.1%.
 * There is no department and no brand here because there is none to have.
 *
 * NEVER THROWS, and never blocks a form. A directory that cannot be reached
 * means the line is not drawn - it must not mean the request cannot be made.
 */

let cached = null;

export async function whoAmI() {
  if (cached) return cached;
  try {
    const res = await fetch('/api/people/me', { headers: { Accept: 'application/json' } });
    if (!res.ok) return null;
    const { me } = await res.json();
    cached = me || null;
    return cached;
  } catch {
    return null;
  }
}

/** Test seam. The module-level cache would otherwise leak between cases. */
export function resetWhoAmI() {
  cached = null;
}
